<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Luisa Dejean lives in Hampshire with her two teenagers. She is a well-being coach and an advocate for the NSPCC. When she isn’t writing or working, you can guarantee she’ll be walking along the beach for new plot lines and twists. Or in the water paddle boarding. Luisa has a passion for all things Harry Potter, <em>The Hobbit</em> and <em>The Lord of the Rings</em>. As well as being a huge fan of rom-coms. You can follow Luisa on Twitter <em>@LilyDGioAuthor</em> and on Instagram and Threads <em>@lilydigiovanni_author</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6c493b3f